









import Plyr from 'plyr';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Player extends Vue {
  player: any = {};

  mounted() {
    this.player = new Plyr(this.$el.firstChild as ChildNode, {
      invertTime: false,
      iconUrl: '/img/plyr/plyr.svg',
      blankVideo: '/img/plyr/blank.mp4',
    });
  }

  // beforeDestroy() {
  //   try {
  //     this.player.destroy();
  //   } catch (e) {
  //     alert(e.message);
  //     if (e.message !== 'The YouTube player is not attached to the DOM.') {
  //       // eslint-disable-next-line no-console
  //       console.error(e);
  //     }
  //   }
  // }
}
